import Button from "@/components/Button/index";
import classname from 'classnames';
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const PrincipalList = ({
	item,
	search,
	displayLimit = 0,
	open = item?.$selected,
	handleEditPrincipal,
	handleViewMorePrincipal,
}) => {

	const [principals, setPrincipals] = useState(item?.principals)

	useEffect(() => {
		if (item?.principals?.length > 0 && search?.length >= 0 && displayLimit == 0) {
			setPrincipals(item?.principals?.filter(principal => principal.principalName?.toLowerCase().includes(search?.toLowerCase()) || principal.principalUEN?.toLowerCase().includes(search)))
		} else {
			setPrincipals(item?.principals)
		}
	}, [search, item.principals])

	const systemId = item?.id;

	const bodyClass = classname({
		'layout_data_elements__row__principal_body': true,
		'layout_data_elements__row__principal_body__scrollable': displayLimit == 0
	})

	return <>
		{principals?.length > 0 && open && (
			<div className="layout_data_elements__row__principal">
				<div className='layout_data_elements__row__principal_header'>
					<span>Principal list</span>
					<Button addClass="layout_data_elements__edit_principal" ghost noborder text="Edit Principals" submit={() => handleEditPrincipal(systemId)} />
				</div>

				<div className={bodyClass}>
					{(displayLimit > 0 ? principals.slice(0, displayLimit) : principals)
						.map((principal, index) => {
							return <div className='layout_data_elements__row__principal' key={index}>
								<div className='layout_data_elements__row__principal__title'>{principal?.principalName}</div>
								<div className='layout_data_elements__row__principal__subtitle'>{`${principal?.principalUEN ? 'UEN: ' + principal.principalUEN : ''}`}</div>
							</div>
						})
					}
				</div>

				{displayLimit > 0 && (item?.principalCount > 5 || item?.principals.length > 5) && (
					<div className='layout_data_elements__row__principal_footer'>
						<Button addClass="layout_data_elements__view_more" ghost noborder text="View More" submit={() => handleViewMorePrincipal(item)} />
					</div>
				)}
			</div>
		)}
	</>
}

PrincipalList.propTypes = {
	item: PropTypes.object,
	search: PropTypes.string,
	displayLimit: PropTypes.number,
	open: PropTypes.bool,
	handleEditPrincipal: PropTypes.func,
	handleViewMorePrincipal: PropTypes.func,
}

export default PrincipalList;
